import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { array, func, object, string } from 'prop-types';
import { useIntl } from 'react-intl';

/**
 * Single-select dropdown of the user's primary school. Options come from the
 * schools chosen in the associated schools field.
 * e.g. associatedSchools=[{ id: 'abc', name: 'Springfield Elementary' }]
 */
const PrimarySchoolField = ({
  associatedSchools,
  selectedSchool,
  handleChange,
  errorMessageId,
}) => {
  const { formatMessage } = useIntl();
  const options = associatedSchools || [];

  return (
    <TextField
      select
      id="primarySchool"
      name="primarySchool"
      required
      label={formatMessage({
        id: 'earlyAccess.createUser.label.primarySchool',
      })}
      value={selectedSchool?.id ?? ''}
      onChange={event =>
        handleChange(options.find(school => school.id === event.target.value))
      }
      error={Boolean(errorMessageId)}
      helperText={errorMessageId ? formatMessage({ id: errorMessageId }) : ''}
      disabled={options.length === 0}
      SelectProps={{
        MenuProps: {
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
        },
      }}
    >
      {options.map(school => (
        <MenuItem key={school.id} value={school.id}>
          {school.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

PrimarySchoolField.propTypes = {
  associatedSchools: array,
  selectedSchool: object,
  handleChange: func.isRequired,
  errorMessageId: string,
};

export default PrimarySchoolField;
